import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchFamilyTreeListAction } from "../../../../../store/actions/PatientsAction";

const FamilyTree = ({ patientDetails, icon3 }) => {
  const dispatch = useDispatch();

  const familyTreeList = useSelector(
    (state) => state.patients?.familyTreeList || []
  );

  useEffect(() => {
    if (patientDetails?.patient_id) {
      // ✅ Pick spouse_patient_id from active marriage if exists
      const activeMarriage = patientDetails?.marriageInfo?.find(
        (m) => m.spouse_option === "With Spouse"
      );

      const idToFetch =
        patientDetails?.patient_with_spouse === "Yes" &&
          activeMarriage?.spouse_patient_id
          ? activeMarriage.spouse_patient_id
          : patientDetails.patient_id;

      dispatch(fetchFamilyTreeListAction(idToFetch));
    }
  }, [dispatch, patientDetails?.patient_id, patientDetails?.patient_with_spouse]);


  const handleOpenPatientDetails = (patientId) => {
    window.open(`/patients/patient-details/${patientId}`, "_blank");
  };

  const handleOpenCasePaper = (patientId) => {
    window.open(`/case-paper/${patientId}`, "_blank");
  };

  // ✅ Extract spouse details safely
  const spouse =
    patientDetails?.marriageInfo?.find(
      (m) => m.spouse_option === "With Spouse"
    ) ||
    patientDetails?.marriageInfo?.[patientDetails.marriageInfo.length - 1] || // fallback to last marriage
    null;

  const spouseName =
    spouse?.husband_or_spouse_name?.trim() ||
    [spouse?.first_name, spouse?.middile_name, spouse?.last_name]
      .filter(Boolean)
      .join(" ");

  const spouseRelation =
    patientDetails?.gender === "Male" ? "Wife" : "Husband";

  // ✅ Check if there is any family data at all
  const hasFamilyData = spouseName || familyTreeList.length > 0;

  return (
    <div className="card shadow-none">
      <div className="card-body">
        {/* <h5 className="fw-bold mb-4">Family History</h5> */}

        {!hasFamilyData ? (
          <p className="text-muted text-center mb-0">No family members found.</p>
        ) : (
          <>
            {/* ✅ Show Spouse */}
            {spouseName && (
              <div className="mb-3 d-flex justify-content-between align-items-center custom-timeline-panel timeline-panel bg-light border-0 p-3 rounded flex-wrap">
                <div>
                  <h6 className="fw-bold mb-1">{spouseName}</h6>
                  <p className="mb-0 fs-15">Relation: {spouseRelation}</p>
                  {spouse?.marriage_history && (
                    <p className="mb-0 text-muted small">
                      Marriage: {spouse.marriage_history} ({spouse.marriage_age})
                    </p>
                  )}
                </div>

                <div className="d-flex align-items-center">
                  {/* Eye Icon - if spouse linked as a patient */}
                  {spouse?.spouse_patient_id && (
                    <>
                      <span
                        onClick={(e) => {
                          e.preventDefault();
                          handleOpenPatientDetails(spouse.spouse_patient_id);
                        }}
                        className="text-info me-3"
                        title="Preview Spouse Details"
                        style={{ cursor: "pointer" }}
                      >
                        <i className="fa fa-eye fs-5" />
                      </span>

                      <img
                        src={icon3 || "/placeholder.svg"}
                        alt="spouse icon"
                        onClick={() =>
                          handleOpenCasePaper(spouse.spouse_patient_id)
                        }
                        style={{
                          cursor: "pointer",
                          width: "28px",
                          height: "28px",
                        }}
                        title="Open Spouse Case-paper"
                      />
                    </>
                  )}
                </div>
              </div>
            )}

            {/* ✅ Family Members */}
            {familyTreeList.length > 0 && (
              <div>
                {familyTreeList.map((member) => (
                  <div
                    key={member.family_id}
                    className="mb-3 d-flex justify-content-between align-items-center custom-timeline-panel timeline-panel bgl-dark border-0 p-3 rounded flex-wrap"
                  >
                    <div>
                      <h6 className="fw-bold mb-1">
                        {member.first_name} {member.middile_name}{" "}
                        {member.last_name}
                      </h6>
                      <p className="mb-0 fs-15">
                        Relation: {member.relation_name}
                      </p>
                    </div>

                    <div className="d-flex align-items-center">
                      <span
                        onClick={(e) => {
                          e.preventDefault();
                          handleOpenPatientDetails(member.family_patient_id);
                        }}
                        className="text-info me-3"
                        title="Preview Patient"
                        style={{ cursor: "pointer" }}
                      >
                        <i className="fa fa-eye fs-5" />
                      </span>

                      <img
                        src={icon3 || "/placeholder.svg"}
                        alt="patient icon"
                        onClick={() =>
                          handleOpenCasePaper(member.family_patient_id)
                        }
                        style={{
                          cursor: "pointer",
                          width: "28px",
                          height: "28px",
                        }}
                        title="Open case-paper"
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default FamilyTree;
